export default __webpack_public_path__ + "static/media/share.f7edc613.svg";